import { updateItemInCollection } from "directus/src/operations";

export async function updateCountry({ item, countryId }) {
  try {
    const data = await updateItemInCollection("countries", countryId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
